import { render, staticRenderFns } from "./ZuUndAbschlaege.vue?vue&type=template&id=76b0a22a"
import script from "./ZuUndAbschlaege.vue?vue&type=script&lang=ts"
export * from "./ZuUndAbschlaege.vue?vue&type=script&lang=ts"
import style0 from "./ZuUndAbschlaege.vue?vue&type=style&index=0&id=76b0a22a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports